import React from 'react';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';

var NotificationIcon = function NotificationIcon(_ref) {
  var showAlertBadge = _ref.showAlertBadge;
  return React.createElement(NavbarHelixIcon, {
    iconName: showAlertBadge ? 'alert_badge' : 'alert'
  });
};

export { NotificationIcon, NotificationIcon as default };